exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.date-field[data-v-f5a10028] {\n    background-color: #fff;\n    background-image: none;\n    border-radius: 4px;\n    border: 1px solid #bfcbd9;\n    box-sizing: border-box;\n    color: #1f2d3d;\n    font-size: inherit;\n    height: 36px;\n    line-height: 1;\n    outline: 0;\n    padding: 3px 10px;\n    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);\n    width: 100%;\n}\n", ""]);

// exports
